/** 节点视觉状态与展示辅助 */

/**
 * 节点视觉状态（作业四态 + 选中降噪）。
 * progress.isActive 单独表现「当前应做」，不占用 status。
 */
export function resolveNodeStatus(item, selectedKey, { dimOthers = false } = {}) {
  if (item?.key && item.key === selectedKey) return 'selected'
  const progressStatus = item?.progress?.status
  const assignmentStatus = item?.assignmentStatus || item?.progress?.assignmentStatus
  const mapped = normalizeQuestStatus(progressStatus, assignmentStatus)
  if (mapped) return mapped
  if (dimOthers && selectedKey) return 'dimmed'
  if (item?.isHighlight) return 'highlight'
  return 'unsubmitted'
}

export function normalizeQuestStatus(progressStatus, assignmentStatus) {
  if (progressStatus === 'unsubmitted' || progressStatus === 'submitted'
    || progressStatus === 'evaluated' || progressStatus === 'rejected') {
    return progressStatus
  }
  // 兼容旧映射
  if (progressStatus === 'upcoming') return 'unsubmitted'
  if (progressStatus === 'pending_review') return 'submitted'
  if (progressStatus === 'done' || progressStatus === 'completed') return 'evaluated'
  if (progressStatus === 'active' || progressStatus === 'in_progress') {
    // 旧版误把打回/当前应做都标成 active；优先用 assignmentStatus
    return statusFromAssignment(assignmentStatus) || 'unsubmitted'
  }
  return statusFromAssignment(assignmentStatus)
}

function statusFromAssignment(assignmentStatus) {
  return ({
    '1': 'unsubmitted',
    '2': 'submitted',
    '3': 'evaluated',
    '4': 'rejected',
  })[String(assignmentStatus || '')] || null
}

/** 与 homeworkStatusLabel / assignment_status 对齐的节点文案 */
export function questProgressLabel(item) {
  const assignmentStatus = item?.assignmentStatus || item?.progress?.assignmentStatus
  const status = normalizeQuestStatus(item?.progress?.status, assignmentStatus)
  const label = ({
    unsubmitted: '未提交',
    submitted: '已提交',
    evaluated: '已完成评价',
    rejected: '已打回',
  })[status]
  if (label) return label
  return ({
    '1': '未提交',
    '2': '已提交',
    '3': '已完成评价',
    '4': '已打回',
  })[String(assignmentStatus)] || ''
}

export function isQuestActive(item) {
  return Boolean(item?.progress?.isActive)
}

export function shortTitle(title, maxLen = 8) {
  const text = String(title || '').trim()
  if (!text) return '未命名'
  if (text.length <= maxLen) return text
  return `${text.slice(0, Math.max(1, maxLen - 1))}…`
}

/** 与门户 --cp-* 一致：蓝 / 绿 / 琥珀点缀 */
export const TYPE_COLOR_VAR = {
  training_process: '#6f9fff',
  group_chat_template: '#34d399',
  expert_agent: '#fbbf24',
}

export const STATUS_COLOR_VAR = {
  unsubmitted: '#8b95a3',
  submitted: '#6f9fff',
  evaluated: '#34d399',
  rejected: '#f87171',
}
